export default __webpack_public_path__ + "static/media/calendar-arrowR.8e8e233e.svg";